import { ChangePasswordData } from '@features/auth/domain/ChangePasswordData';
import { ChangePasswordResponse } from '@features/auth/domain/ChangePasswordResponse';
import axios from 'helpers/axios';

const changePasswordRequest = async ({
  token,
  newPassword,
}: ChangePasswordData) => {
  try {
    const response = await axios.post(`/api/user/resetpassword/${token}`, {
      password: newPassword,
      confirmPassword: newPassword,
    });
    return response.data as ChangePasswordResponse;
  } catch (error) {
    const errorCode = error?.response?.data?.errorCode;
    throw new Error(errorCode || 'ERROR_UNKNOWN_ERROR');
  }
};

export default changePasswordRequest;
